import { CheckboxComponent, TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import { Box, Divider, Typography } from "@mui/material";
import { ColorUtils } from "../../utils/ColorUtils";

interface Props {
  control: any;
  register: any;
  errors: any;
}

function WelcomeFormFields({ control, register, errors }: Props) {
  return (
    <>
      <Divider sx={{ backgroundColor:ColorUtils.LIGHT_GRAY, marginLeft: 2, marginTop:3, marginBottom: 3}}/>

      <Typography sx={{ marginLeft: 1, marginBottom: 1 }} variant="h6">Welcome Form Information</Typography>

      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        inputType="text"
        propertyName={"welcomeFormInfo.wordDescription"}
        label={"Personal Description"}
        required={false}
      />
      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        inputType="text"
        propertyName={"welcomeFormInfo.hobbies"}
        label={"Hobbies"}
        required={false}
      />
      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        inputType="text"
        propertyName={"welcomeFormInfo.pets"}
        label={"Pets"}
        required={false}
      />
      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        inputType="text"
        propertyName={"welcomeFormInfo.favouriteGame"}
        label={"Favourite Game"}
        required={false}
      />
      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        inputType="text"
        propertyName={"welcomeFormInfo.musicPreferences"}
        label={"Favourite genre/band"}
        required={false}
      />
      <CheckboxComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={"welcomeFormInfo.student"}
        label="Is a student"
        required={false}
      />
    </>
  );
}

export default WelcomeFormFields;
